import * as React from "react";
import * as BS from "react-bootstrap";
import { Link } from "react-router-dom";
import { Paths } from "../../../constants";

interface OwnProps {
    eventId: number;
    view: "Abstracts" | "Disclosures" | "Acceptance emails";
}

export const AbstractsViewSwitcher: React.SFC<OwnProps> = (props) => {
    return <BS.DropdownButton id="views" title={props.view}>
        <li className={props.view === "Abstracts" ? "active" : ""}><Link role="menuitem" to={Paths.AdminAbstractList(props.eventId)}>Abstracts</Link></li>
        <li className={props.view === "Disclosures" ? "active" : ""}><Link role="menuitem" to={Paths.AdminAbstractDisclosures(props.eventId)}>Disclosures</Link></li>
        <li className={props.view === "Acceptance emails" ? "active" : ""}><Link role="menuitem" to={Paths.AdminAbstractInvitationEmails(props.eventId)}>Acceptance emails</Link></li>
        <li><Link role="menuitem" to={Paths.AdminEventCalendarEdit(props.eventId)}>Calendar</Link></li>
    </BS.DropdownButton>;
};



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/components/AbstractsViewSwitcher.tsx